import React from 'react';
import { Row, Col} from 'react-bootstrap';
import cx from 'classnames';

const ChartBar = React.createClass({
  _percentageValues() {
    return (this.props.data[this.props.type] * 100).toFixed(2) + '%';
  },

  _dynamicClasses(classes) {
    return cx(`${classes}`, `${classes}${this.props.type}`);
  },

  _isOtherPresent() {
    const percentageValues = this._percentageValues();
    if (this.props.data[this.props.type] > 0) {
      return (
        <div className="chart-bar">
          <Row>
            <Col xs={12} md={2}>
              <div className={this._dynamicClasses('chart-bar__label chart-bar__label--')}>
                {this.props.type}
              </div>
            </Col>
            <Col xs={12} md={1}>
              <div className="chart-bar__value">{percentageValues}</div>
            </Col>
            <Col xs={12} md={9}>
              <div className="chart-bar__line-wrapper">
                <div className={this._dynamicClasses("chart-bar__line chart-bar__line--")}
                  style={{width: percentageValues}}>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      );
    }
  },

  render() {
    return <div>{this._isOtherPresent()}</div>
  }
});

export default ChartBar;



/** WEBPACK FOOTER **
 ** ./src/components/charts/bar.js
 **/